import Layout from "../../assets/Layout";
import UserLayout from "../../assets/UserLayout";
import {
  Box,
  Button,
  Grid,
  IconButton,
  InputBase,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import profilePhoto from "../../images/profilePhoto.png";
import VideocamRoundedIcon from "@mui/icons-material/VideocamRounded";
import Rating from "@mui/material/Rating";
import FacebookRoundedIcon from "@mui/icons-material/FacebookRounded";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import ReviewCard from "../../assets/cards/ReviewCard";
import React, { useState } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

export default function RescheduleService() {
  const [date, setDate] = useState(new Date())
  const [time, setTime] = useState("")

  const handleSubmit=()=>{
    console.log(time, date)
  }

  return (
    <>
      <Layout>
        <UserLayout userRole={"candidate"}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              mt: 8,
              borderRadius: "10px",
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: "bold", width: "100%" }}>
              Reschedule of UI-UX Design
            </Typography>
            <Grid
              item
              md={4}
              sx={{
                display: "flex",
                verticalAlign: "middle",
                alignItems: "center",
              }}
            >
              <TextField
                sx={{ marginLeft: "1rem", backgroundColor: "#D9E3F6" }}
                className="profile-skills-box text2Light"
                variant="outlined"
                size="small"
                placeholder="Search"
                InputProps={{
                  endAdornment: <SearchIcon sx={{ opacity: "0.5" }} />,
                }}
              />
            </Grid>
          </Box>

          <Grid container spacing={2}>
            <Grid item md={8.5}>
              <Box p={3}>
                <Paper
                  sx={{
                    width: "100%",
                    bgcolor: "#F8FAFF",
                    boxShadow:
                      "0px 40.30877685546875px 80.6175537109375px -15.115790367126465px #3665D014",
                    border: "1.72px solid #cedefd",
                  }}
                >
                  <Box sx={{ p: 3, display: "flex", justifyContent: "center" }}>
                    <Grid container>
                      <Grid item xs={12} md={3.5}>
                        <Box>
                          <img
                            src={profilePhoto}
                            alt="profilePhoto"
                            style={{ height: "200px" }}
                          />
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={8.5}>
                        <Box sx={{ fontFamily: "Inter", px: 3 }}>
                          <Typography
                            sx={{
                              lineHeight: "43px",
                              opacity: ".5",
                            }}
                            className="text1Mid"
                          >
                            (8784421)
                          </Typography>
                          <Typography
                            sx={{
                              lineHeight: "40px",
                              color: "#061C3D",
                            }}
                            className="subHeading2Bold"
                          >
                            Anuj Sharma
                          </Typography>
                          <Rating
                            name="half-rating-read"
                            defaultValue={4}
                            precision={0.5}
                            readOnly
                            sx={{ py: 1 }}
                          />
                          <Typography
                            sx={{
                              lineHeight: "35px",
                            }}
                            className=""
                          >
                            Lorem ipsum dolor sit amet consectetur. Turpis in
                            sapien in a nunc nibh volutpat. Massa mattis
                            molestie amet dui volutpat. Tellus lacinia pulvinar
                            pharetra viverra morbi tincidunt mi mus.
                          </Typography>
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                </Paper>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <Typography
                      sx={{
                        fontfamily: "Inter",
                        fontSize: "25px",
                        fontWeight: 600,
                        lineHeight: "75px",
                      }}
                    >
                      Select Time Slot
                    </Typography>
                    <Box>
                      <Calendar onChange={(e) => setDate(e.target.value)} value={date} />
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Typography
                      sx={{
                        fontfamily: "Inter",
                        fontSize: "25px",
                        fontWeight: 600,
                        lineHeight: "75px",
                      }}
                    >
                      Pick Up Time in Between
                    </Typography>
                    <Box>
                      <Grid container spacing={2}>
                        <Grid item xs={6} md={4}>
                          {" "}
                          <Typography
                            sx={{
                              fontfamily: "Inter",
                              fontSize: "14px",
                              fontWeight: 600,
                              bgcolor: "#2544EE",
                              color: "#fff",
                              opacity: 0.5,
                              textAlign: "center",
                              py: 2,
                              px: 3,
                              borderRadius: "30px",
                            }}
                          >
                            Session 1
                          </Typography>
                        </Grid>
                        <Grid item xs={6} md={4}>
                          {" "}
                          <Typography
                            sx={{
                              fontfamily: "Inter",
                              fontSize: "14px",
                              fontWeight: 600,
                              bgcolor: "#2544EE",
                              color: "#fff",
                              opacity: 0.5,
                              textAlign: "center",
                              py: 2,
                              px: 3,
                              borderRadius: "30px",
                            }}
                          >
                            Session 2
                          </Typography>
                        </Grid>
                        <Grid item xs={6} md={4}>
                          {" "}
                          <Typography
                            sx={{
                              fontfamily: "Inter",
                              fontSize: "14px",
                              fontWeight: 600,
                              bgcolor: "#2544EE",
                              color: "#fff",
                              opacity: 0.5,
                              textAlign: "center",
                              py: 2,
                              px: 3,
                              borderRadius: "30px",
                            }}
                          >
                            Session 3
                          </Typography>
                        </Grid>
                        <Grid item xs={6} md={4}>
                          {" "}
                          <Typography
                            sx={{
                              fontfamily: "Inter",
                              fontSize: "14px",
                              fontWeight: 600,
                              bgcolor: "#2544EE",
                              color: "#fff",
                              textAlign: "center",
                              py: 2,
                              px: 3,
                              borderRadius: "30px",
                            }}
                          >
                            Session 4
                          </Typography>
                        </Grid>
                        <Grid item xs={6} md={4}>
                          {" "}
                          <Typography
                            sx={{
                              fontfamily: "Inter",
                              fontSize: "14px",
                              fontWeight: 600,
                              border: "1px solid #2544EE",
                              color: "#2544EE",
                              textAlign: "center",
                              py: 2,
                              px: 3,
                              borderRadius: "30px",
                            }}
                          >
                            Session 5
                          </Typography>
                        </Grid>
                        <Grid item md={12}>
                          {" "}
                          <Typography
                            sx={{
                              fontfamily: "Inter",
                              fontSize: "18px",
                              fontWeight: 600,
                              border: "1px solid #2544EE",
                              color: "#000",
                              textAlign: "center",
                              py: 2,
                              px: 3,
                              borderRadius: "30px",
                            }}
                          >
                            1:00 PM - 06:00 PM
                          </Typography>
                        </Grid>
                        <Grid item md={12}>
                          {" "}
                          <Typography
                            sx={{
                              fontfamily: "Inter",
                              fontSize: "18px",
                              fontWeight: 600,
                              border: "1px solid #2544EE",
                              color: "#000",
                              textAlign: "center",
                              py: 2,
                              px: 3,
                              borderRadius: "30px",
                            }}
                          >
                            07:30 PM - 09:00 PM
                          </Typography>
                        </Grid>
                        <Grid item md={12}>
                          <Box
                            sx={{
                              bgcolor: "#F8FAFF",
                              boxShadow:
                                "0px 26.398801803588867px 52.797603607177734px -9.89954948425293px #3665D014",
                              border: "1px solid #cedefd",
                              borderRadius: "20px",
                            }}
                          >
                            <Box p={2}>
                              <Typography
                                sx={{
                                  fontfamily: "Inter",
                                  fontSize: "20px",
                                  fontWeight: 600,
                                  mb: 2,
                                }}
                              >
                                Enter Time
                              </Typography>
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                {/* <Box
                                  sx={{
                                    display: "flex",
                                    fontfamily: "Inter",
                                    fontSize: "18px",
                                    fontWeight: 600,
                                    border: "1px solid #2544EE",
                                    color: "#000",
                                    textAlign: "center",
                                    py: 2,
                                    px: 3,
                                    borderRadius: "30px",
                                    gap: 2,
                                    width: "70%",
                                  }}
                                >
                                  <AccessTimeIcon
                                    sx={{ fontSize: "20px", color: "#2544EE" }}
                                  />
                                  <Typography sx={{ fontSize: "14px" }}>
                                    Enter Starting Time
                                  </Typography>
                                </Box> */}

                                <input
                                  style={{
                                    display: "flex",
                                    fontfamily: "Inter",
                                    fontSize: "18px",
                                    fontWeight: 600,
                                    border: "1px solid #2544EE",
                                    color: "#000",
                                    textAlign: "center",
                                    padding: "15px",
                                    borderRadius: "30px",
                                    gap: 2,
                                    width: "70%",
                                  }}
                                  type="text"
                                  onChange={(e) => setTime(e.target.value)}
                                  value={time}
                                  placeholder="Enter Starting Time"
                                />

                                <Button
                                  variant="contained"
                                  sx={{ bgcolor: "#2544EE", px: 3 }}
                                  onClick={handleSubmit}
                                >
                                  Done
                                </Button>
                              </Box>
                            </Box>
                          </Box>
                        </Grid>

                        <Grid item md={12}>
                          <Grid container>
                            <Grid item xs={12} md={6}>
                              <Box>
                                <Typography
                                  sx={{
                                    fontfamily: "Inter",
                                    fontSize: "25px",
                                    fontWeight: 600,
                                    lineHeight: "75px",
                                  }}
                                >
                                  Medium
                                </Typography>
                                <Box
                                  sx={{
                                    bgcolor: "#2544EE",
                                    color: "#fff",
                                    px: 4,
                                    py: 1,
                                    maxWidth: "90px",
                                    height: "45px",
                                    borderRadius: "30px",
                                  }}
                                >
                                  <VideocamRoundedIcon />
                                </Box>
                              </Box>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Box>
                                <Box>
                                  <Typography
                                    sx={{
                                      fontfamily: "Inter",
                                      fontSize: "25px",
                                      fontWeight: 600,
                                      lineHeight: "75px",
                                    }}
                                  >
                                    Language
                                  </Typography>
                                  <Box display={"flex"} gap={2}>
                                    <Typography
                                      sx={{
                                        fontfamily: "Inter",
                                        fontSize: "14px",
                                        fontWeight: 600,
                                        bgcolor: "#2544EE",
                                        color: "#fff",
                                        textAlign: "center",
                                        py: 2,
                                        px: 3,
                                        borderRadius: "30px",
                                      }}
                                    >
                                      English
                                    </Typography>
                                    <Typography
                                      sx={{
                                        fontfamily: "Inter",
                                        fontSize: "14px",
                                        fontWeight: 600,
                                        border: "1px solid #2544EE",
                                        color: "#2544EE",
                                        textAlign: "center",
                                        py: 2,
                                        px: 3,
                                        borderRadius: "30px",
                                      }}
                                    >
                                      Hindi
                                    </Typography>
                                  </Box>
                                </Box>
                              </Box>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Box>
                  </Grid>
                </Grid>
                <Grid item md={12}>
                  <Typography
                    sx={{
                      fontfamily: "Inter",
                      fontSize: "25px",
                      fontWeight: 600,
                      lineHeight: "75px",
                    }}
                  >
                    Selected Date & Time For Session 4
                  </Typography>

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: { xs: "column", md: "row" },
                      justifyContent: "space-between",
                      textAlign: "center",
                      boxShadow:
                        "0px 23.48060417175293px 46.96120834350586px -8.80522632598877px #3665D014",
                      p: 2,
                      borderRadius: "20px",
                      gap: { xs: 2, md: 0 },
                    }}
                  >
                    <Box>
                      <Typography
                        sx={{
                          fontfamily: "Inter",
                          fontSize: "16px",
                          fontWeight: 600,
                        }}
                      >
                        26 April 2023 at 02:00 PM - 03:00 PM
                      </Typography>
                    </Box>

                    <Box display={"flex"} gap={1}>
                      <Typography
                        sx={{
                          fontfamily: "Inter",
                          fontSize: "16px",
                          fontWeight: 600,
                        }}
                      >
                        Medium :
                      </Typography>
                      <Box
                        sx={{
                          bgcolor: "#2544EE",
                          color: "#fff",
                          px: 3,
                          borderRadius: "30px",
                        }}
                      >
                        <VideocamRoundedIcon />
                      </Box>
                    </Box>

                    <Box display={"flex"} gap={1}>
                      <Typography
                        sx={{
                          fontfamily: "Inter",
                          fontSize: "16px",
                          fontWeight: 600,
                        }}
                      >
                        Language :
                      </Typography>
                      <Box>
                        <Typography
                          sx={{
                            fontfamily: "Inter",
                            fontSize: "14px",
                            fontWeight: 600,
                            bgcolor: "#2544EE",
                            color: "#fff",
                            textAlign: "center",
                            px: 4,
                            borderRadius: "30px",
                            py: "5px",
                          }}
                        >
                          English
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </Grid>
              </Box>
              <Box sx={{ textAlign: "center" }}>
                <Button
                  variant="contained"
                  className="text1Mid"
                  sx={{
                    px: 5,
                    py: 2,
                    bgcolor: "#2544EE",
                    borderRadius: "10px",
                    my: 5,
                  }}
                  endIcon={<KeyboardArrowRightIcon />}
                >
                  Confirm Schedule
                </Button>
              </Box>
            </Grid>
            <Grid item md={3.5}>
              <Box py={5}>
                <Typography
                  sx={{
                    fontfamily: "Inter",
                    fontSize: "25px",
                    fontWeight: 600,
                    lineHeight: "75px",
                  }}
                >
                  Social Media
                </Typography>
                <Stack direction="row" spacing={1}>
                  <IconButton sx={{ bgcolor: "#2544EE", color: "#fff" }}>
                    <FacebookRoundedIcon />
                  </IconButton>
                  <IconButton sx={{ bgcolor: "#2544EE", color: "#fff" }}>
                    <TwitterIcon />
                  </IconButton>
                  <IconButton sx={{ bgcolor: "#2544EE", color: "#fff" }}>
                    <LinkedInIcon />
                  </IconButton>
                  <IconButton sx={{ bgcolor: "#2544EE", color: "#fff" }}>
                    <InstagramIcon />
                  </IconButton>
                </Stack>
                <Box>
                  <Typography
                    sx={{
                      fontfamily: "Inter",
                      fontSize: "25px",
                      fontWeight: 600,
                      lineHeight: "75px",
                    }}
                  >
                    Reviews
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item md={12}>
                      <ReviewCard />
                    </Grid>
                    <Grid item md={12}>
                      <ReviewCard />
                    </Grid>
                    <Grid item md={12}>
                      <ReviewCard />
                    </Grid>
                    <Grid item md={12}>
                      <ReviewCard />
                    </Grid>
                  </Grid>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </UserLayout>
      </Layout>
    </>
  );
}
